import { render, staticRenderFns } from "./CF7Vendas.vue?vue&type=template&id=631e0031&"
import script from "./CF7Vendas.vue?vue&type=script&lang=js&"
export * from "./CF7Vendas.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CF7Vendas.vue?vue&type=style&index=1&id=631e0031&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports